import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { handleAuthBounce } from "@/native/links";
import { isNative } from "@/native/platform";
import { queryClient } from "@/lib/queryClient";
import { persistCache, restoreCache } from "@/lib/persistCache";
import { installErrorReporter } from "@/lib/errorReporter";

installErrorReporter();

// The phone app opens on what it showed last time and refreshes it in the background,
// like a native app (src/lib/persistCache.js). Put back before the first render.
if (isNative()) {
  document.documentElement.classList.add("native");  // touch styles in index.css
  restoreCache(queryClient, localStorage.getItem("token"));
  persistCache(queryClient, () => localStorage.getItem("token"));
}

// A prerendered page (scripts/prerender.mjs) carries the head tags the page wrote at
// build time; the app writes them again when it renders, so the old ones go first.
document.head.querySelectorAll("[data-prerendered]").forEach((el) => el.remove());

// The browser shows the first <title>; the shell's generic one (data-shell) gives way
// as soon as a page sets its own, and so do its description and social tags.
new MutationObserver(() => {
  if (document.head.querySelector("title:not([data-shell])")) {
    document.head.querySelectorAll("[data-shell]").forEach((el) => el.remove());
  }
}).observe(document.head, { childList: true });

// In the system browser a third-party sign-in started by the iOS / Android app hands
// back to the app here (src/native/links.js); then the page itself never renders.
if (!handleAuthBounce()) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <App />,
  );
}
